import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import './App.css';
import { withRouter } from "react-router-dom";
//import { Navbar } from "react-bootstrap";
//import { CssBaseline, GlobalStyles } from '@material-ui/core';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { createTheme, makeStyles, ThemeProvider} from '@material-ui/core/styles';

//import { Nav, NavItem} from "react-bootstrap";
//import { NavLink, Link } from 'react-router-dom';
//import {LinkContainer} from 'react-router-bootstrap';
//import Form from 'react-bootstrap/Form';
//import Button from 'react-bootstrap/Button';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Routes from "./Routes";
//import NavItems from "./containers/navItems";
//import CreditsNav from "./containers/CreditsNav";
import * as actions from './store/actions/index';
import DisplaySnackbar from './containers/DisplaySnackbar';
import ButtonAppBar from './containers/ButtonAppBar';

//import 'bootstrap';

const drawerWidth = 240;

function App(props) {

    useEffect(()=> {
        props.onTryAutoSignin();
    },[]);

    const theme = createTheme({
        palette: {
            type: "light"
        }
    });

    const themeLight = createTheme({
        palette: {
            background: {
                default: "#2da749"
            }
        }
    });

    const themeDark = createTheme({
        palette: {
            background: {
                default: "#222222"
            },
            text: {
                primary: "#ffffff"
            }
        }
    });

    const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
    const [light, setLight] = React.useState(true);
    console.log('is mobile', isMobile);

    // sx={{ display: 'flex' }}
//sx={{ flexGrow: 1, p: 0 }}
    // <Box sx={ (!isMobile && { display: 'flex' })}>
    // <Box component="main" sx={ (!isMobile && { flexGrow: 1, p: 0 })}>
    //, width: { sm: `calc(100% - ${drawerWidth}px)` }
    // body: { backgroundColor: "#f6f7fb" }
    return (
        <ThemeProvider theme={light ? themeLight : themeDark}>
            <CssBaseline/>
            <GlobalStyles
                styles={{
                    body: { backgroundColor: "#f6f7fb" }
                }}
            />
        <div className="App">
            <DisplaySnackbar />
            <Box sx={ (!isMobile && { display: 'flex' })}>
            {props.isAuthenticated && <ButtonAppBar/>}
            <Box component="main" sx={ (!isMobile && { flexGrow: 1, p: 0 })}>
                <Toolbar />
                <Routes />
            </Box>
            </Box>
        </div>
        </ThemeProvider>
    );
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        role: state.auth.role
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignin: () => dispatch(actions.checkAuthState())
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
